(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('mimeTypeUtility', mimeTypeUtility);

	function mimeTypeUtility(_) {
		var mediaKinds = {
			doc: ['msword', 'wordprocessing', 'opendocument[.]text', 'powerpoint', 'presentation', 'opendocument[.]presentation'],
			xls: ['excel', 'spreadsheet'],
			pdf: ['pdf'],
			zip: ['zip', 'x-rar-compressed', 'x-tar'],
			psd: [],
			ai: [],
			fw: [],
			indd: [],
			application: [],
			image: [],
			video: [],
			audio: [],
			text: []
		};

		function getFileKind(mediaType) {
			var kind = _.findKey(mediaKinds, function (patterns) {
				return _.any(patterns, function (pattern) {
					return new RegExp(pattern, 'gi').test(mediaType);
				});
			});

			if (!kind) {
				var mimeType = splitMimeType(mediaType);
				if (mimeType)
					kind = mimeType.type;
			}

			return kind || 'unknown';
		}

		function splitMimeType(mimeType) {
			if (!mimeType)
				return null;

			var parts = mimeType.split('/');
			if (parts.length !== 2)
				return null;

			return {
				type: parts[0],
				subtype: parts[1]
			};
		}

		return {
			getFileKind: getFileKind,
			splitMimeType: splitMimeType
		};
	}
	mimeTypeUtility.$inject = ['_'];
})();